import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { resendLogic, ResendState } from 'utils/resendLogic';
import { getYourContactData } from 'selectors/getYourContact';
import { setResendState, ContactType } from 'handlers/yourContact';

import { useResendState } from './useResendState';

export const useResendLogic = (contactType: ContactType) => {
  const dispatch = useDispatch();
  const { emailResendState, phoneResendState, email, phone_number: phoneNumber } = useSelector(getYourContactData);

  const currentResendState = (contactType === ContactType.Email
    ? { ...emailResendState, contactValue: email }
    : { ...phoneResendState, contactValue: phoneNumber }) as ResendState;

  const { remainingTime, getFormattedTime } = useResendState(currentResendState);

  const recordSent = useCallback(
    (contactValue: string) => {
      const newResendState = resendLogic.createNewResendState(contactValue, currentResendState);
      dispatch(setResendState({ contactType, state: newResendState }));
    },
    [contactType, dispatch, emailResendState, phoneResendState],
  );

  const resetTimer = useCallback(() => {
    dispatch(setResendState({ contactType, state: null }));
  }, [contactType, dispatch]);

  const isTimerActive = remainingTime > 0;
  const canResend = remainingTime === 0;
  const shouldShowConfirmation = resendLogic.shouldShowConfirmation(currentResendState);

  return {
    remainingTime,
    isTimerActive,
    canResend,
    shouldShowConfirmation,
    recordSent,
    resetTimer,
    getFormattedTime,
  };
};
